import { useEffect } from "react";
import { useSelector } from "react-redux";
import useShiftTimes from "./useShiftTimes";

import { RootState } from "../../state/store";

export function useApplyTheme() {
  const pref = useSelector((s: RootState) => s.theme.preference);
  const { selectedShift } = useShiftTimes();

  useEffect(() => {
    const root = document.documentElement;
    root.dataset.theme = pref;
    root.dataset.shift = selectedShift === "NIGHT" ? "night" : "day";
  }, [pref, selectedShift]);

  return { resolved: pref };
}
